import { NgIf, NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { AgrNumberDirective } from '@next/core-lib/form';
import { TranslatePipe } from '@next/core-lib/i18n';

@Component({
  selector: 'app-wdo-registration-form',
  templateUrl: './wdo-registration-form.component.html',
  imports: [
    ReactiveFormsModule,
    NgIf,
    MatFormField,
    MatLabel,
    MatInput,
    AgrNumberDirective,
    MatSuffix,
    NgClass,
    MatIcon,
    TranslatePipe,
  ],
})
export class WDORegistrationFormComponent {
  @Input() formGroup: FormGroup;
  @Input() showFields: string[];
  @Input() feedIntakeSuffix: string;
  @Input() waterIntakeSuffix: string;
  @Input() feedIntakePlaceholder: string;
  @Input() waterIntakePlaceholder: string;
  @Input() chickAgeInDays: number;

  showField(fieldToShow: string): boolean {
    return !!this.showFields && this.showFields.findIndex((field) => field === fieldToShow) > -1;
  }
}
